import {nextTick, unref, watch} from 'vue';
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {storeToRefs} from "pinia";
import GoingUtils from "@/utils/goingUtils";


export default function ({initCtlData, dataConfig,queryParams={}}) {
  const dataSourceStore = useDataSourceStore();
  const {dataListCache}: any = storeToRefs(dataSourceStore);

  const watchDesConfig = function () {
    if(unref(dataConfig)){
      if (!GoingUtils.isDesFlag()) {
        watch(() => {
            return unref(dataConfig).records;
          }, () => {

            nextTick(() => {
              //如果是系统变更 不触发查询
              if(unref(dataConfig).systemChange){
                nextTick(()=>{
                  unref(dataConfig).systemChange=false;
                });
                return;
              }
              initCtlData && initCtlData();
            })
          }, {
            deep: true, // 深度监听
          }
        );
      }
      // 监听内容变化
      watch(()=>[unref(dataConfig).url,unref(dataConfig).moduleId,unref(dataConfig).domainCode,unref(dataConfig).orderFieldList], () => {
          nextTick(() => {
            initCtlData && initCtlData();
          })
        }, {
          deep: true, // 深度监听
        }
      );
    }
  }

  const watchDataConfig = function () {
    if(unref(dataConfig)){
      watch(() => {
          return unref(dataConfig).records;
        }, () => {
          nextTick(() => {
            //如果是系统变更 不触发查询
            if(unref(dataConfig).systemChange){
              nextTick(()=>{
                unref(dataConfig).systemChange=false;
              });
              return;
            }
            initCtlData && initCtlData();
          })
        }, {
          deep: true, // 深度监听
        }
      );
      // 监听内容变化
      watch(() => {
          return unref(dataListCache)[unref(dataConfig).selId];
        }, () => {
          nextTick(() => {
            initCtlData && initCtlData();
          })
        }, {
          deep: true, // 深度监听
        }
      );

      // 监听内容变化
      watch(queryParams, () => {
          nextTick(() => {
            initCtlData && initCtlData();
          })
        }, {
          deep: true, // 深度监听
        }
      );

    }
  }
  //开发模式下 需要监听数据变化进行查询操作
  if (GoingUtils.isDesFlag()) {
    //目的延时执行监听 减少重复查询
    nextTick(() => {
      watchDataConfig();
      watchDesConfig();
    })
  } else {
    watchDataConfig();
  }

  return {
    watchDesConfig,
    watchDataConfig
  }
}
